import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { Capacitor } from '@capacitor/core';
import { Socket } from 'ngx-socket-io';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  tap,
  throwError,
} from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ActivityFilters } from './activity.model';
import { readToken } from '../_auth/token-store';
import { CustomSnackbarComponent } from '../shared/custom-snackbar/custom-snackbar.component';
@Injectable({
  providedIn: 'root',
})
export class RestserviceService {
  // PRODUCTION URL
  // public api_url_v2 = environment.API_URL;
  // REMOTE DEV
  public api_url_v2 =
    'https://dev.sensor.auton.in/cu-communication-service-dev/api-v2/eyeton';
  // FOR LOCAL DEVELOPMENT
    // public api_url_v2 =
    // 'http://localhost:8080/cu-communication-service-dev/api-v2/eyeton';
  token: any;
  userEmail: any;
  httpHeaders: any;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private subscribedTopics = new Set<string>(); // ✅ Track subscribed topics
  private activeSubscriptions = new Map<string, Observable<any>>();
  loading$ = this.loadingSubject.asObservable();
  messages: { text: string; type: string }[] = [];
  private userSubscribed = false; // Flag to track user topic subscription
  private isWebSocketConnected = false; // ✅ Add this
  constructor(
    private snackBar: MatSnackBar,
    private http: HttpClient,
    private socket: Socket,
  ) {
    this.token = readToken();
  }

  getPlans(): Observable<any[]> {
    return this.http.get<any[]>('/assets/config/pricing-plans.json');
  }

  private async getIpAddress(): Promise<string> {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch {
      return '0.0.0.0';
    }
  }

  // async registerToken(fcmToken: string) {
  //   const payload = {
  //     fcmToken: fcmToken,
  //     deviceInfo: Capacitor.getPlatform(),
  //     ipAddress: await this.getIpAddress(),
  //     userAgent: navigator.userAgent
  //   };

  //   return this.http.post(
  //     `${this.api_url_v2}/fcm-tokens/register-token`,
  //     payload,
  //     this.httpHeaders
  //   ).subscribe({
  //     next: (res) => console.log('✅ Token registered:', res),
  //     error: (err) => console.error('❌ Token registration failed:', err)
  //   });
  // }

  // registerToken(fcmToken: string) {
  //   console.log('📤 registerToken called with:', fcmToken);

  //   const payload = {
  //     fcmToken: fcmToken,
  //     deviceInfo: Capacitor.getPlatform(),
  //     ipAddress: '0.0.0.0',
  //     userAgent: navigator.userAgent
  //   };

  //   console.log('📦 Payload:', JSON.stringify(payload));
  //   console.log('🔗 URL:', `${this.api_url_v2}/fcm-tokens/register-token`);

  //   return this.http.post(
  //     `${this.api_url_v2}/fcm-tokens/register-token`,
  //     payload,
  //     this.httpHeaders
  //   ).subscribe({
  //     next: (res) => console.log('✅ Token registered:', res),
  //     error: (err) => console.error('❌ Token registration failed:', err)
  //   });
  // }
  registerToken(fcmToken: string) {
    console.log('📤 registerToken called with:', fcmToken);

    const payload = {
      fcmToken: fcmToken,
      deviceInfo: Capacitor.getPlatform(),
      ipAddress: '0.0.0.0',
      userAgent: navigator.userAgent,
    };

    console.log('📦 Payload:', JSON.stringify(payload));
    console.log('🔗 URL:', `${this.api_url_v2}/fcm-tokens/register-token`);

    // ✅ Get fresh token from localStorage every time
    const freshToken = readToken();

    // ✅ Create fresh headers
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: freshToken,
      },
    };

    console.log('🔑 Auth header:', freshToken ? 'Token present' : 'No token');

    return this.http
      .post(
        `${this.api_url_v2}/fcm-tokens/register-token`,
        payload,
        headers, // ✅ Use fresh headers instead of this.httpHeaders
      )
      .subscribe({
        next: (res) => console.log('✅ Token registered:', res),
        error: (err) => console.error('❌ Token registration failed:', err),
      });
  }

  logoutUser(fcmToken?: string) {
    const freshToken = readToken();

    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: freshToken,
      },
    };

    const url = fcmToken
      ? `${this.api_url_v2}/user/logout?fcmToken=${fcmToken}`
      : `${this.api_url_v2}/user/logout`;

    return this.http.patch(url, {}, headers);
  }

  logoutAllDevices() {
    const freshToken = readToken();

    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: freshToken,
      },
    };

    return this.http.delete(
      `${this.api_url_v2}/user/logout/all-devices`,
      headers,
    );
  }

  showSnackbar(
    message: string,
    type: 'success' | 'error' | 'info' = 'info',
    duration: number = 3000,
  ): MatSnackBarRef<CustomSnackbarComponent> {
    const ref = this.snackBar.openFromComponent(CustomSnackbarComponent, {
      duration,
      data: {
        message,
        type,
        ref: null, // temp
      },
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar-panel'],
    });

    return ref;
  }
  private topicSubscriptions: Map<string, Subscription> = new Map();
  websocketConnect(
    RusList: any[],
    callback: (id: string, payload: any) => void,
  ): void {
    this.isWebSocketConnected = true;
    const userId = localStorage.getItem('userId');

    const uniqueRusList = Array.from(
      new Set(RusList.map((obj) => obj.frontendTopic)),
    ).map((topic) => RusList.find((obj) => obj.frontendTopic === topic));

    uniqueRusList.forEach((obj) => {
      if (!obj?.cameraAvailable) return;

      const id = `${obj.frontendTopic}-image`;

      if (!this.subscribedTopics.has(id)) {
        this.subscribedTopics.add(id);

        const sub = this.getSpecificEvent(id).subscribe((res: any) => {
          callback(id, res.payload);
        });

        // ✅ keep track of the subscription
        this.topicSubscriptions.set(id, sub);
      }
    });

    if (!this.userSubscribed) {
      const userTopic = `${userId}`;
      const sub = this.getSpecificEvent(userTopic).subscribe((data: any) => {
        this.showToast(data.message, data.notificationLevel || 'info');
        window.dispatchEvent(
          new CustomEvent('new-toast', {
            detail: {
              message: data.message,
              type: data.notificationLevel || 'info',
            },
          }),
        );
      });
      this.topicSubscriptions.set(userTopic, sub);
      this.userSubscribed = true;
    }
  }
  disconnectWebsocket(): void {
    this.topicSubscriptions.forEach((sub) => sub.unsubscribe());
    this.topicSubscriptions.clear();
    this.subscribedTopics.clear();
    this.userSubscribed = false;
    this.isWebSocketConnected = false;
  }

  /**
   * Shared live stream for a device topic.
   *
   * One socket listener per topic is multiplexed to every subscriber. `refCount`
   * is deliberately `true`: with the default (`false`) the source subscription is
   * never torn down, so the teardown below never ran — the socket handler stayed
   * registered and the `activeSubscriptions` entry was never evicted, for the
   * lifetime of the tab. With refCount the listener is detached once the last
   * subscriber leaves and re-attached on the next subscribe.
   */
  getSpecificEvent(topic: string): Observable<any> {
    if (this.activeSubscriptions.has(topic)) {
      return this.activeSubscriptions.get(topic)!;
    }

    const observable = new Observable((observer) => {
      const eventHandler = (data: any) => {
        observer.next(data);
      };

      this.socket.on(topic, eventHandler);
      this.socket.emit('subscribe', topic);

      return () => {
        // Pass the handler reference — `off(topic)` with no handler would
        // remove *every* listener on this topic, including other components'.
        this.socket.off(topic, eventHandler);
        this.activeSubscriptions.delete(topic); // ✅ Remove from tracking
      };
    }).pipe(shareReplay({ bufferSize: 1, refCount: true }));

    this.activeSubscriptions.set(topic, observable);
    return observable;
  }

  // showToast(message: string, type: 'success' | 'danger' | 'warning' | 'info' = 'info') {
  //   this.messages.push({ text: message, type });
  //   if (this.messages.length > 10) {
  //     this.messages.shift();
  //   }
  // }

  showToast(
    message: string,
    type: 'success' | 'danger' | 'warning' | 'info' = 'info',
  ) {
    // Check if the message already exists to avoid duplicates
    if (
      this.messages.some((msg) => msg.text === message && msg.type === type)
    ) {
      return; // Do not add the duplicate message
    }

    const newToast = { text: message, type };

    // Add new toast at the beginning (latest on top)
    this.messages.unshift(newToast);

    // Ensure only 5 toasts are kept (remove oldest if exceeding limit)
    if (this.messages.length > 5) {
      this.messages.pop(); // Removes the last (oldest) toast
    }

    setTimeout(() => {
      this.messages = this.messages.filter((msg) => msg !== newToast);
    }, 3000);
  }

  updateUserView(view: string): Observable<any> {
    console.log('view', view);
    const userEmail = localStorage.getItem('userEmail');

    if (!userEmail) {
      console.error('User email not found in localStorage');
      return throwError(() => new Error('User email not found'));
    }

    const formattedView = this.formatView(view);
    const payload = { lastSelectedView: formattedView };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `${readToken()}`, // Modify as needed
    });

    return this.http
      .put(
        `${this.api_url_v2}/user/update-user-view-screen/${userEmail}`,
        payload,
        { headers },
      )
      .pipe(
        tap(() => {
          // ✅ Update localStorage after successful API call
          localStorage.setItem('selectedView', formattedView);
        }),
      );
  }

  /** Layouts the backend `Views` enum can persist. Keep the two in sync. */
  static readonly KNOWN_VIEWS = ['MODERN', 'EDIT', 'GAUGE', 'SORTED'];

  /**
   * Coerce a stored/received view name into one this build can render.
   *
   * 'DEFAULT' is the legacy name for what is now EDIT, but it was also the value
   * every account was created with — so it never signalled a deliberate choice.
   * Map it to MODERN, the new default, rather than dropping people into the
   * editable layout. Anything unrecognised also falls back to MODERN, so a bad
   * value can never render a blank dashboard.
   */
  normalizeView(view: string | null | undefined): string {
    if (!view) {
      return 'MODERN';
    }
    const upper = `${view}`.trim().toUpperCase();
    return RestserviceService.KNOWN_VIEWS.includes(upper) ? upper : 'MODERN';
  }

  private formatView(view: string): string {
    return this.normalizeView(view);
  }
  enterFullscreen() {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).mozRequestFullScreen) {
      (elem as any).mozRequestFullScreen();
    } else if ((elem as any).webkitRequestFullscreen) {
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) {
      (elem as any).msRequestFullscreen();
    }
  }

  exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  }

  isFullscreen(): boolean {
    return !!document.fullscreenElement;
  }

  show() {
    this.loadingSubject.next(true);
  }
  hide() {
    this.loadingSubject.next(false);
  }
  isAuthenticated(): string | null {
    const token = readToken();
    this.userEmail = localStorage.getItem('userEmail');
    if (token) {
      this.httpHeaders = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: token,
        }),
      };
    }
    return token;
  }
  // login(data: Record<string, any>): Promise<any> {
  //   const url = `${this.api_url_v2}/auth/login`;
  //   return this.http.post(url, data).toPromise();
  // }
  login(data: Record<string, any>) {
    const url = `${this.api_url_v2}/auth/login`;
    return this.http.post(url, data);
  }

  userForgotPassword(data: Record<string, any>, email: string): Promise<any> {
    const url = `${this.api_url_v2}/auth/reset-password/${email}`;
    return this.http.patch(url, data, this.httpHeaders).toPromise();
  }
  raiseComplaint(data: Record<string, any>): Promise<any> {
    const url = `${this.api_url_v2}/raise-complaint`;
    return this.http.post(url, data, this.httpHeaders).toPromise();
  }

  deleteUser(email: any) {
    return this.http.delete(
      this.api_url_v2 + '/user/delete-user/' + email,
      this.httpHeaders,
    );
  }

  // deleteDataaa(_id: any) {
  //   const url = `https://dev.sensor.auton.in/eyeton/${_id}`;
  //   return this.http.delete(url);
  // }
  deleteDataaa(_id: any) {
    const url = `https://dev.sensor.auton.in/ocr-dev/${_id}`;
    return this.http.delete(url);
  }

  getNotifications(userId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.api_url_v2}/notification/get-notifications-by-userId/${userId}`,
      { headers: this.httpHeaders.headers }, // Ensure only headers are passed, not extra options
    );
  }
  // Mark notification as read
  markNotificationAsRead(notificationId: string): Observable<any> {
    return this.http.put(
      `${this.api_url_v2}/notification/mark-notification-as-read/${notificationId}`,
      {},
      this.httpHeaders,
    );
  }
  markAllNotificationsAsRead(userId: string): Observable<any> {
    return this.http.put(
      `${this.api_url_v2}/notification/mark-all-notifications-as-read/${userId}`,
      {},
      this.httpHeaders,
    );
  }

  /**
   * Turn a filter object into query params, dropping empties and expanding
   * arrays into repeated params (`?category=ALERT&category=SECURITY`) — which is
   * what the backend's List<T> @RequestParam binding expects.
   */
  private toActivityParams(filters: ActivityFilters): HttpParams {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        return;
      }
      if (Array.isArray(value)) {
        value
          .filter((entry) => entry !== null && `${entry}`.trim() !== '')
          .forEach((entry) => {
            params = params.append(key, `${entry}`);
          });
      } else if (`${value}`.trim() !== '') {
        params = params.append(key, `${value}`);
      }
    });
    return params;
  }

  /**
   * Admin activity feed. Only non-empty filters are sent as query params.
   * `from`/`to` must be ISO date-time strings (LocalDateTime on the backend).
   * Returns the paged envelope { content, totalElements, totalPages, page, size }.
   */
  getActivities(filters: ActivityFilters): Observable<any> {
    return this.http.get<any>(`${this.api_url_v2}/activity/get-activities`, {
      params: this.toActivityParams(filters),
    });
  }

  /** Aggregates (totals, failures, top actors, timeline) for the same filter. */
  getActivityStats(filters: ActivityFilters): Observable<any> {
    return this.http.get<any>(`${this.api_url_v2}/activity/stats`, {
      params: this.toActivityParams(filters),
    });
  }

  /** Distinct values present in the window, for populating the filter dropdowns. */
  getActivityFacets(from?: string, to?: string): Observable<any> {
    return this.http.get<any>(`${this.api_url_v2}/activity/facets`, {
      params: this.toActivityParams({ from, to }),
    });
  }

  /** Every event recorded while handling one request. */
  getActivityTrace(correlationId: string): Observable<any> {
    return this.http.get<any>(
      `${this.api_url_v2}/activity/trace/${encodeURIComponent(correlationId)}`,
    );
  }

  /** Every address an account has signed in from. */
  getActivityLoginSources(actor: string): Observable<any> {
    return this.http.get<any>(`${this.api_url_v2}/activity/login-sources`, {
      params: this.toActivityParams({ actor }),
    });
  }

  /** CSV of the filtered feed, as a Blob ready to hand to a download anchor. */
  exportActivities(filters: ActivityFilters): Observable<Blob> {
    return this.http.get(`${this.api_url_v2}/activity/export`, {
      params: this.toActivityParams(filters),
      responseType: 'blob',
    });
  }

  deleteRoom(id: any) {
    return this.http
      .delete(this.api_url_v2 + '/room/delete-room/' + id, this.httpHeaders)
      .toPromise();
  }

  deleteComplaint(id: string | number): Promise<any> {
    const url = `${this.api_url_v2}/raise-complaint/delete-complaint/${id}`;
    return this.http.delete(url, this.httpHeaders).toPromise();
  }

  enableDisableRoom(id: any) {
    return this.http.put(
      this.api_url_v2 + '/room/enable-disable-room/' + id,
      null,
      this.httpHeaders,
    );
  }

  createPlantV2(data: string) {
    return this.http.post(
      this.api_url_v2 + '/plant/create-plant',
      data,
      this.httpHeaders,
    );
  }
  //MOHIT
  sendChatQuery(question: string): Observable<any> {
    const payload = {
      question: question,
    };

    return this.http.post(
      `${this.api_url_v2}/copilot/query`,
      payload,
      this.httpHeaders,
    );
  }
  // end
  updatePlant(id: string, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/plant/update-plant/' + id,
        data,
        this.httpHeaders,
      )
      .toPromise();
  }
  updateRoom(id: string, data: any) {
    return this.http
      .put(this.api_url_v2 + '/room/update-room/' + id, data, this.httpHeaders)
      .toPromise();
  }
  updateComplaint(id: string, data: any) {
    return this.http
      .patch(
        this.api_url_v2 +
          '/raise-complaint/update-ticket-status/' +
          id +
          '?status=' +
          data,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }
  //LINK ROOM TO PLANT
  linkRoomToPlant(id: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/plant/link-room-to-plant/' + id + '/' + data.roomId,
        this.httpHeaders,
      )
      .toPromise();
  }
  //ASSIGN PLANT TO USER
  assignnPlantToUser(email: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 +
          '/user/assign-plant-to-user/' +
          email +
          '/' +
          data.plantId,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }
  //ASSIGN Room TO USER
  assignnRoomToUser(email: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 +
          '/user/assign-room-to-user/' +
          email +
          '/' +
          data.roomId,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }
  //ASSIGN RU TO USER
  assignnRuToUser(email: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/user/assign-ru-to-user/' + email + '/' + data.ruId,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }
  //ASSIGN CS TO USER
  assignnCsToUser(email: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/user/assign-cs-to-user/' + email + '/' + data.csId,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }
  //ASSIGN ORGANIZATION TO USER
  assignnOrganizationToUser(email: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 +
          '/user/assign-organization-to-user/' +
          email +
          '/' +
          data.organizationId,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }

  //LINK RU TO ROOM
  linkRuToRoom(id: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/room/link-ru-to-room/' + id + '/' + data.ruId,
        this.httpHeaders,
      )
      .toPromise();
  }
  // DELINK ROOM FROM PLANT
  deLinkRoomFromPlant(id: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 +
          '/plant/delink-room-from-plant/' +
          id +
          '/' +
          data.roomId,
        this.httpHeaders,
      )
      .toPromise();
  }
  // GET PLANT BY ID
  getPlantById() {
    return this.http.get(
      this.api_url_v2 + '/plant/get-plant-by-id/',
      this.httpHeaders,
    );
  }
  getCsByRoomId(id: any) {
    return this.http.get(
      this.api_url_v2 + '/room/get-cs-by-roomId/' + id,
      this.httpHeaders,
    );
  }
  //getOrganizationById
  getOrganizationById(id: any) {
    return this.http.get(
      this.api_url_v2 + '/organization/get-organization-by-id/' + id,
      this.httpHeaders,
    );
  }
  getAllRoomsByPlantId(id: any) {
    return this.http.get(
      this.api_url_v2 + '/room/get-all-rooms-by-plantId/' + id,
      this.httpHeaders,
    );
  }
  getAllRuOfGuest() {
    return this.http.get(
      this.api_url_v2 + '/guest-ru/get-all-ru-of-guest',
      this.httpHeaders,
    );
  }

  // GET ALL PLANT API V2
  getAllPlantsV2() {
    return this.http.get(
      this.api_url_v2 + '/plant/get-all-plants',
      this.httpHeaders,
    );
  }
  // DELETE PLANT API V2
  deletePlant(id: any) {
    return this.http
      .delete(this.api_url_v2 + '/plant/delete-plant/' + id, this.httpHeaders)
      .toPromise();
  }

  // ENABLE OR DISABLE PLANT
  enableDisablePlant(id: any) {
    return this.http.put(
      this.api_url_v2 + '/plant/enable-disable-plant/' + id,
      null,
      this.httpHeaders,
    );
  }

  enableDisableCondition(id: any) {
    return this.http.put(
      this.api_url_v2 + '/ru/enable-disable-condition/' + id,
      null,
      this.httpHeaders,
    );
  }
  toggleAudio(id: any) {
    return this.http.put(
      this.api_url_v2 + '/ru/mute-unmute-ru/' + id,
      null,
      this.httpHeaders,
    );
  }

  //  PLANT CONTROLLER END

  //FOR SORTING V2
  // GET DEVICES BY PLANT
  getDevicesByPlant(email: any) {
    return this.http.get(
      this.api_url_v2 + '/user/get-devices-by-plant/' + email,
      this.httpHeaders,
    );
  }

  //ROOM CONTROLLER V2

  //GET ALL ROOMS API V2
  getAllRoomsV2() {
    return this.http.get(
      this.api_url_v2 + '/room/get-all-rooms',
      this.httpHeaders,
    );
  }

  //GET ALL COMPLAINTS
  getAllComplaints() {
    return this.http.get(
      this.api_url_v2 + '/raise-complaint/get-all-complaints',
      this.httpHeaders,
    );
  }

  // CREATE NEW ROOM V2
  createNewRoomV2(data: any) {
    return this.http
      .post(this.api_url_v2 + '/room/create-room', data, this.httpHeaders)
      .toPromise();
  }
  //ROOM CONTROLLER END V2

  // CS CONTROLLER V2

  // CREATE NEW CS API V2
  createNewCsV2(data: any) {
    return this.http
      .post(this.api_url_v2 + '/cu/create-cs', data, this.httpHeaders)
      .toPromise();
  }
  //GET ALL USERS API V2
  getAllUsersV2() {
    return this.http.get(
      this.api_url_v2 + '/user/get-all-users',
      this.httpHeaders,
    );
  }
  /**
   * Forecast for one RU. `historyDays` sets how much past data the model sees;
   * `horizonHours` how far ahead it projects. A `forecastable: false` body is a
   * successful response (device stale, series constant) — only a 503 means the
   * forecasting service itself is down.
   */
  getRuForecast(
    ruId: string,
    historyDays: number,
    horizonHours: number,
  ): Observable<any> {
    return this.http.get(
      `${this.api_url_v2}/ru/forecast/${ruId}?historyDays=${historyDays}&horizonHours=${horizonHours}`,
      this.httpHeaders,
    );
  }

  getAllRus(): Observable<any> {
    return this.http.get(`${this.api_url_v2}/ru/get-all-rus`, this.httpHeaders);
  }

  getAllReadings() {
    return this.http.get(
      this.api_url_v2 + '/ru/get-all-measurement-units',
      this.httpHeaders,
    );
  }

  deleteRu(id: any) {
    return this.http
      .delete(this.api_url_v2 + '/ru/delete-ru/' + id, this.httpHeaders)
      .toPromise();
  }
  // DELETE GUEST RU
  deleteGuestRu(id: any) {
    return this.http
      .delete(
        this.api_url_v2 + '/guest-ru/delete-guest-ru/' + id,
        this.httpHeaders,
      )
      .toPromise();
  }
  // CS CONTROLLER V2
  deleteCs(id: any) {
    return this.http
      .delete(this.api_url_v2 + '/cu/delete-cs/' + id, this.httpHeaders)
      .toPromise();
  }

  // GET ALL CS'S V2
  getAllCs() {
    return this.http.get(this.api_url_v2 + '/cu/get-all-cs', this.httpHeaders);
  }

  // GET ALL DEVICES V2
  getAllDevicesOfUser() {
    let email = localStorage.getItem('userEmail');
    return this.http.get(
      this.api_url_v2 + '/user/get-all-devices-of-user/' + email,
      this.httpHeaders,
    );
  }

  // EDIT [CROP] RU IMAGE
  edit(param: any) {
    return this.http.post(
      this.api_url_v2 + '/ru/edit-ru-image',
      param,
      this.httpHeaders,
    );
  }

  // v2
  updateMinimum(data: any, ruId: any) {
    return this.http
      .patch(
        this.api_url_v2 + '/ru/update-ru-label-and-min-max/' + ruId,
        { minimumReading: data },
        this.httpHeaders,
      )
      .toPromise();
  }
  // v2
  updateMaximum(data: any, ruId: any) {
    return this.http
      .patch(
        this.api_url_v2 + '/ru/update-ru-label-and-min-max/' + ruId,
        { maximumReading: data },
        this.httpHeaders,
      )
      .toPromise();
  }
  // v2
  updateRuLabel(data: any, ruId: any) {
    return this.http
      .patch(
        this.api_url_v2 + '/ru/update-ru-label-and-min-max/' + ruId,
        { ruLabel: data },
        this.httpHeaders,
      )
      .toPromise();
  }
  // UPDATE CS LABEL API v2
  updateCsLabel(csId: any, data: any) {
    return this.http.patch(
      this.api_url_v2 + '/cu/update-cs-label/' + csId,
      data,
      this.httpHeaders,
    );
  }

  // ALL CS TIME SCHEDULES V2
  getAllTimeSlots(csId: any) {
    return this.http.get(
      this.api_url_v2 + '/cu/get-cs-schedule-by-csId/' + csId,
      this.httpHeaders,
    );
  }
  // GET ALL CONDITONS FOR RU
  getAllConditions(ruId: any): Observable<any> {
    return this.http.get(
      `${this.api_url_v2}/ru/get-all-conditions-by-ruId/${ruId}`,
      this.httpHeaders,
    );
  }
  //delete condition
  deleteCondition(id: any) {
    return this.http
      .delete(this.api_url_v2 + '/ru/delete-condition/' + id, this.httpHeaders)
      .toPromise();
  }

  // EXCEL RU REPORT
  excelRuReport(requestData: any): Promise<Blob> {
    const isNative = Capacitor.isNativePlatform();
    return this.http
      .post(this.api_url_v2 + '/report/export-ru-data', requestData, {
        ...this.httpHeaders,
        responseType: isNative ? ('text' as 'json') : ('blob' as 'json'), // Conditionally avoid parsing errors
      })
      .toPromise()
      .then((response: any) => {
        if (typeof response === 'string') {
          return new Blob([response], { type: 'text/csv' });
        }
        if (response instanceof Blob) {
          return response; // Ensure response is a Blob
        } else {
          throw new Error('Unexpected response format');
        }
      })
      .catch((error) => {
        console.error('Error in excelRuReport:', error);
        throw error; // Propagate error to handle in getReport
      });
  }

  //EXPORT CS DATA TO EXCEL
  excelCsReport(requestData: any): Promise<Blob> {
    const isNative = Capacitor.isNativePlatform();
    return this.http
      .post(this.api_url_v2 + '/report/export-cs-data', requestData, {
        ...this.httpHeaders,
        responseType: isNative ? ('text' as 'json') : ('blob' as 'json'), // Conditionally avoid parsing errors
      })
      .toPromise()
      .then((response: any) => {
        if (typeof response === 'string') {
          return new Blob([response], { type: 'text/csv' });
        }
        if (response instanceof Blob) {
          return response; // Ensure response is a Blob
        } else {
          throw new Error('Unexpected response format');
        }
      })
      .catch((error) => {
        console.error('Error in excelRuReport:', error);
        throw error; // Propagate error to handle in getReport
      });
  }
  // FOR PROGRESS BAR IN GENERATING EXCEL
  public generateExcelProgress(id: any) {
    return this.http.get(
      this.api_url_v2 + '/report/progress?requestId=' + id,
      this.httpHeaders,
    );
  }

  // RU CONTROLLER V2
  // CREATE NEW RU DEVICE V2
  registerRu(data: any) {
    return this.http
      .post(this.api_url_v2 + '/ru/create-ru', data, this.httpHeaders)
      .toPromise();
  }
  // CREATE NEW RU FOR GUEST
  registerGuestRu(data: any) {
    return this.http
      .post(
        this.api_url_v2 + '/guest-ru/create-guest-ru',
        data,
        this.httpHeaders,
      )
      .toPromise();
  }
  //RESET PASSWORD FOR ADMIN
  resetPasswordAdmin(email: any) {
    return this.http
      .patch(
        this.api_url_v2 + '/auth/reset-password-admin/' + email,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }
  createNewCsSchedule(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.api_url_v2}/cu/create-cs-schedule`,
      data,
      this.httpHeaders,
    );
  }
  //CREATE NEW CONDITON FOR RU
  createNewCondition(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.api_url_v2}/ru/create-new-condition`, // API endpoint
      data, // Data to be sent in the request body
      this.httpHeaders, // Custom headers
    );
  }

  sendMessage(msg: string) {
    this.socket.emit('message', msg);
  }
  getMessage() {
    // return this.socket.fromEvent<string>('message');
    return this.socket.fromEvent<string, any>('message');
  }
  /**
   * Live stream for a CS (Control Unit) topic.
   *
   * Delegates to `getSpecificEvent` — the wiring is identical (`socket.on` +
   * `emit('subscribe')`), and the previous standalone implementation had two
   * defects the shared one doesn't: it registered a fresh listener per
   * subscriber (no caching), and its teardown called `socket.off(topic)` with
   * no handler reference, which removed every listener on that topic and so
   * silently killed other components watching the same CS.
   */
  getCsButtonStatus(topic: string): Observable<any> {
    return this.getSpecificEvent(topic);
  }

  // NEW CODE BELOW
  //                                            ORGANIZATION CONTROLLER V2
  createNewOrganization(data: FormData) {
    const token = this.token ? this.token.toString() : ''; // Ensure token is a valid string

    let headers = new HttpHeaders({
      Authorization: token, // Use an empty string as a fallback if token is undefined
    });

    return this.http
      .post(this.api_url_v2 + '/organization/create-organization', data, {
        headers,
      })
      .toPromise();
  }
  // GET ALL ORGANIZATIONS
  getAllOrganizationsV2() {
    return this.http.get(
      this.api_url_v2 + '/organization/get-all-organizations',
      this.httpHeaders,
    );
  }
  // GET ALL USER DEVICES IN GROUPED VIEW
  getAllUserDevicesInGroupedView(email: any) {
    return this.http.get(
      this.api_url_v2 + '/user/get-all-devices-in-grouped-view/' + email,
      this.httpHeaders,
    );
  }

  getAllAdminUserDevicesInGroupedView() {
    return this.http.get(
      this.api_url_v2 + '/user/get-all-devices-in-grouped-view',
      this.httpHeaders,
    );
  }

  // GET ALL DEVICES IN ADMIN GROUPED VIEW
  getAllAdminDevicesInGroupedView() {
    return this.http.get(
      this.api_url_v2 +
        '/user/get-all-devices-in-grouped-view' +
        this.httpHeaders,
    );
  }
  //assignOrganizationToUser V2
  assignOrganizationToUser(data: any) {
    return this.http.put(
      this.api_url_v2 +
        '/user/assign-organization-to-user/' +
        data.email +
        '/' +
        data.organizationId,
      this.httpHeaders,
    );
  }
  //assignPlantToUser V2
  assignPlantToUser(data: any) {
    return this.http.post(
      this.api_url_v2 + '/user/assign-plant-to-user/',
      data,
      this.httpHeaders,
    );
  }
  //assignRoomToUser V2
  assignRoomToUser(data: any) {
    return this.http.post(
      this.api_url_v2 + '/user/assign-room-to-user/',
      data,
      this.httpHeaders,
    );
  }
  //assignRuToUser V2
  assignRuToUser(data: any) {
    return this.http.post(
      this.api_url_v2 + '/user/assign-ru-to-user/',
      data,
      this.httpHeaders,
    );
  }
  //assignCSToUser V2
  assignCsToUser(data: any) {
    return this.http.post(
      this.api_url_v2 + '/user/assign-cs-to-user/',
      data,
      this.httpHeaders,
    );
  }
  // DELETE ORGANISATION V2
  deleteOrganization(id: any) {
    return this.http
      .delete(
        this.api_url_v2 + '/organization/delete-organization/' + id,
        this.httpHeaders,
      )
      .toPromise();
  }
  //UPDATE ORGANIZATION
  updateOrganization(id: string, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/organization/update-organization/' + id,
        data,
        this.httpHeaders,
      )
      .toPromise();
  }
  //UPDATE USER
  updateUser(email: any, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/user/update-user/' + email,
        data,
        this.httpHeaders,
      )
      .toPromise();
  }
  async getThisUserLog(userId: any): Promise<any> {
    try {
      return await this.http
        .get(this.api_url_v2 + '/put/here/' + userId, this.httpHeaders)
        .toPromise();
    } catch (error: any) {
      // Check API error structure
      if (error.error && error.error.title) {
        throw new Error(
          `API error: ${error.error.title} - ${error.error.detail}`,
        );
      } else {
        throw new Error('Something went wrong. Please try again later.');
      }
    }
  }
  // async demoAccountReadings(): Promise<any> {
  //   try {
  //     return await this.http
  //       .get('https://dev.sensor.auton.in/eyeton/')
  //       .toPromise();
  //   } catch (error: any) {
  //     if (error.error && error.error.title) {
  //       throw new Error(`API error: ${error.error.title} - ${error.error.detail}`);
  //     } else {
  //       throw new Error('Something went wrong. Please try again later.');
  //     }
  //   }
  // }
  async demoAccountReadings(): Promise<any> {
    try {
      return await this.http
        .get('https://dev.sensor.auton.in/ocr-dev/')
        .toPromise();
    } catch (error: any) {
      if (error.error && error.error.title) {
        throw new Error(
          `API error: ${error.error.title} - ${error.error.detail}`,
        );
      } else {
        throw new Error('Something went wrong. Please try again later.');
      }
    }
  }

  async getThisRuGraphData(deviceId: any): Promise<any> {
    try {
      return await this.http
        .get(this.api_url_v2 + '/report/graph/' + deviceId, this.httpHeaders)
        .toPromise();
    } catch (error: any) {
      // Check API error structure
      if (error.error && error.error.title) {
        throw new Error(
          `API error: ${error.error.title} - ${error.error.detail}`,
        );
      } else {
        throw new Error('Something went wrong. Please try again later.');
      }
    }
  }
  // UPDATE ORGANIZATION LOGO
  // updateOrganizationLogo(id: string, data: any) {
  //   let Header: any = {
  //     headersV2: new HttpHeaders({
  //       Authorization: this.token,
  //     }),
  //   };
  //   return this.http
  //     .put(
  //       this.api_url_v2 + '/organization/update-organization-logo/' + id,
  //       data,
  //       Header
  //     )
  //     .toPromise();
  // }
  updateOrganizationLogo(id: string, data: FormData) {
    let headers = new HttpHeaders({
      Authorization: `${this.token}`,
    });
    return this.http
      .put(
        `${this.api_url_v2}/organization/update-organization-logo/${id}`,
        data,
        { headers },
      )
      .toPromise();
  }

  //ENABLE OR DISABLE THE ORGANIZATION
  enableDisableOrganization(id: any) {
    return this.http.patch(
      this.api_url_v2 + '/organization/enable-disable-organization/' + id,
      null,
      this.httpHeaders,
    );
  }

  //ENABLE OR DISABLE THE USER
  enableDisableUser(email: any) {
    return this.http.patch(
      this.api_url_v2 + '/user/enable-disable-user/' + email,
      null,
      this.httpHeaders,
    );
  }

  // ADD PLANT TO THE ORGANIZATION
  addPlantToOrganization() {
    return this.http.patch(
      this.api_url_v2 + '/organization/add-plant-to-organization/',
      this.httpHeaders,
    );
  }
  // ADD USER TO THE ORGANIZATION
  addUserToOrganization(id: string, email: any) {
    return this.http
      .patch(
        this.api_url_v2 +
          '/organization/add-user-to-organization/' +
          id +
          '/' +
          email,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }
  // REMOVE USER FROM ORGANIZATION
  removeUserFromOrganization(id: string, email: any) {
    return this.http
      .patch(
        this.api_url_v2 +
          '/organization/remove-user-from-organization/' +
          id +
          '/' +
          email,
        null,
        this.httpHeaders,
      )
      .toPromise();
  }

  // REMOVE PLANT FROM ORGANIZATION
  removePlantFromOrganization() {
    return this.http.patch(
      this.api_url_v2 + '/organization/remove-plant-from-organization/',
      this.httpHeaders,
    );
  }
  //GET ALL USER ACCESS
  getAlluserAccess(email: any) {
    return this.http.get(
      this.api_url_v2 + '/user/get-all-user-access/' + email,
      this.httpHeaders,
    );
  }

  //  CS CONTROLLER

  // CONTROL CS DEVICE API V2
  controlCsDevice(param: any) {
    return this.http.post(
      this.api_url_v2 + '/cu/control-cs',
      param,
      this.httpHeaders,
    );
  }
  // DELETE CS SLOT V2
  deleteSlot(id: any) {
    return this.http
      .delete(
        this.api_url_v2 + '/cu/delete-cs-schedule/' + id,
        this.httpHeaders,
      )
      .toPromise();
  }
  //ENABLE OR DISABLE THE CS DEVICE
  enableDisableCsDevice(id: any) {
    return this.http.put(
      this.api_url_v2 + '/cu/enable-disable-cs/' + id,
      null,
      this.httpHeaders,
    );
  }

  //ENABLE OR DISABLE THE USER ACCESS
  enableDisableUserAccess(id: any) {
    return this.http.put(
      this.api_url_v2 + '/user/enable-disable-user-access/' + id,
      null,
      this.httpHeaders,
    );
  }

  deleteUserAccess(id: any) {
    return this.http
      .delete(
        this.api_url_v2 + '/user/delete-user-access/' + id,
        this.httpHeaders,
      )
      .toPromise();
  }

  //ENABLE OR DISABLE THE RU DEVICE
  enableDisableRuDevice(id: any) {
    return this.http.put(
      this.api_url_v2 + '/ru/enable-disable-ru/' + id,
      null,
      this.httpHeaders,
    );
  }
  //ENABLE OR DISABLE THE GUEST RU DEVICE
  enableDisableGuestRuDevice(id: any) {
    return this.http.patch(
      this.api_url_v2 + '/guest-ru/enable-disable-guest-ru/' + id,
      null,
      this.httpHeaders,
    );
  }
  // UPDATE CS DEVICE
  updateCsDevice(id: string, data: any) {
    return this.http
      .put(this.api_url_v2 + '/cu/update-cs/' + id, data, this.httpHeaders)
      .toPromise();
  }
  // UPDATE RU DEVICE
  updateRuDevice(id: string, data: any) {
    return this.http
      .put(this.api_url_v2 + '/ru/update-ru/' + id, data, this.httpHeaders)
      .toPromise();
  }
  //UPDATE GUEST RU DEVICE
  updateGuestRuDevice(id: string, data: any) {
    return this.http
      .put(
        this.api_url_v2 + '/guest-ru/update-guest-ru/' + id,
        data,
        this.httpHeaders,
      )
      .toPromise();
  }
  // CREATE NEW USER V2
  registerNewUser(data: any) {
    return this.http
      .post(this.api_url_v2 + '/user/create-user', data, this.httpHeaders)
      .toPromise();
  }
}
